import React from 'react';
import ErrorsConfig from '../components/ErrorsConfig/ErrorsConfig';
import AuthenticatedLayout from '../components/AuthenticatedLayout';

export default function CaseErrorsConfig() {
    return (
        <AuthenticatedLayout title="Configuração de Erros">
            <ErrorsConfig />
        </AuthenticatedLayout>
    );
}
